<template>
  <div
    :class="`BaseImage--${size}`"
    :style="[
      size == 'aspect-ratio' && {
        paddingBottom: `${(height / width) * 100}%`,
      },
    ]"
    class="BaseImage"
  >
    <img
      v-lazyload
      :alt="alt"
      :data-src="src"
      :data-srcset="srcset"
      decoding="async"
      class="BaseImage-image u-posAbsoluteCenter"
    />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    srcset: {
      type: String,
      default: undefined,
    },
    size: {
      type: String,
      default: "aspect-ratio",
      validator: (value) => ["aspect-ratio", "cover"].includes(value),
    },
    width: {
      type: Number,
      default: 960,
    },
    height: {
      type: Number,
      default: 540,
    },
    alt: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
.BaseImage {
  position: relative;
  overflow: hidden;
}

.BaseImage--cover {
  width: 100%;
  height: 100%;
}

.BaseImage-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.5s $easeOutQuad;
}

.BaseImage-image[data-lazyload="loaded"] {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// BaseImage.vue?71a41742